export default __webpack_public_path__ + "static/media/teachers.623ed7f2.svg";